import React, { useEffect, useState } from "react";
import apiCompany from "../../../apis/company/apiCompany";
import apiDinner from "../../../apis/dinner/apiDinner";
import AppAlert from "../../common/AppAlert";
import AppLoading from "../../common/AppLoading";
import BreadCrumb from "../../common/AppBreadCrumb";
import AppInput from "../../controls/AppInput";
import AppSelect from "../../controls/AppSelect";
import AppTitle from "../../controls/AppTitle";

function DinnerPointCreateForm() {
	const [name, setName] = useState("");
	const [dinner, setDinner] = useState({});
	const [loading, setLoading] = useState(false);
	const [dinnerList, setDinnerList] = useState([]);
	const [errorsForm, setErrorsForm] = useState({});

	const CreateDinnerPoint = async () => {
		const dinner_point = {
			name: name,
			dinner_id: dinner.value,
		};

		setLoading(true);
		const response = await apiDinner.createDinnerPoint(dinner_point);
		setLoading(false);

		if (response.ok) {
			AppAlert.SimpleAlert(response.message);
			setErrorsForm({});
		} else {
			setErrorsForm(response);
		}
	};

	const GetDinners = async () => {
		const response = await apiDinner.getDinnersDropdown();

		if (response.ok) {
			setDinnerList(response.data);
		}
	};

	useEffect(() => {
		GetDinners();
	}, []);

	return (
		<div className="row">
			<div className="col-12">
				<AppTitle text="Registro Punto de Servicio:" />
				<BreadCrumb items={[{ label: "Puntos Servicio" }, { label: "Registro Punto de Servicio", active: true }]} />
			</div>
			<div className="card col-12">
				<div className="row card-body col-12">
					<div className="col-6">
						<AppInput
							label="Nombre del punto de Servicio"
							type="text"
							onChange={({ target }) => setName(target.value)}
							placeholder="Nombre del punto de Servicio"
							errors={errorsForm.name}
						/>
					</div>
					<div className="col-6">
						<AppSelect label="Comedor" items={dinnerList} onChange={(dinner) => setDinner(dinner ? dinner : {})} errors={errorsForm.dinner_id} />
					</div>
					<div className="col-12 text-center my-4">
						<button className="btn btn-primary" onClick={CreateDinnerPoint}>
							Registrar Punto de Servicio
						</button>
					</div>
				</div>
			</div>
			<AppLoading visible={loading} />
		</div>
	);
}

export default DinnerPointCreateForm;
